module.exports = __webpack_public_path__ + "static/img/idshow.16a144f1.jpg";